import { isdvirOnly, hasRestrictedRole } from 'globalutils/fmUtils';

// Service providers that show mechanics
const serviceProviders = ['simplex', 'radius', 'trackit', 'ft', 'hcss', 'patriot', 'nauto', '2bro', 'tts'];

export const isMechanicVisible = (RTFMuser) => {
  const env = window.$environment;
  return (
    (isdvirOnly() && !hasRestrictedRole(['FLMANAGER'])) ||
    RTFMuser ||
    env.CURRENT_LAYOUT !== 'Clutch' ||
    serviceProviders.includes(env.SERVICE_PROVIDER)
  );
};

export const buttonConfigs = [
  {
    labelKey: 'users.All',
    type: 'All',
    selected: (userRole) => !userRole,
    show: ({ isServiceManager }) => !isServiceManager,
  },
  {
    labelKey: 'users.drivers',
    type: 'Driver',
    selected: (userRole) => userRole === 'driver',
    show: ({ isServiceManager }) => !isServiceManager,
  },
  {
    labelKey: 'users.mechanics',
    type: 'Mechanic',
    selected: (userRole) => userRole === 'mechanic',
    show: ({ RTFMuser }) => isMechanicVisible(RTFMuser),
  },
  {
    labelKey: 'users.fleetManager',
    type: 'Fleet Manager',
    selected: (userRole) => userRole === 'fleetmanager',
    show: ({ isServiceManager, insuracePortalUserRole }) => !isServiceManager && !insuracePortalUserRole,
  },
  {
    labelKey: 'common.admin',
    type: 'Admin',
    selected: (userRole) => userRole === 'admin',
    show: ({ isServiceManager, insuracePortalUserRole }) => !isServiceManager && !insuracePortalUserRole,
  },
  {
    labelKey: 'users.underWriters',
    type: 'Under Writer',
    selected: (userRole) => userRole === 'underwriter',
    show: ({ insuracePortalUserRole }) => insuracePortalUserRole,
  },
  {
    labelKey: 'users.lossControllers',
    type: 'Loss Control',
    selected: (userRole) => userRole === 'loss-control',
    show: ({ insuracePortalUserRole }) => insuracePortalUserRole,
  },
  {
    labelKey: 'users.claimManagers',
    type: 'Claim Adjuster',
    selected: (userRole) => userRole === 'claim-adjuster',
    show: ({ insuracePortalUserRole }) => insuracePortalUserRole,
  },
];

// Generate button configuration dynamically
export const generateFilterButtons = ({ i18n, userRole, isServiceManager, insuracePortalUserRole, RTFMuser }) => {
  return buttonConfigs
    .filter((btn) => btn.show({ isServiceManager, insuracePortalUserRole, RTFMuser }))
    .map((btn) => ({
      label: i18n.t(btn.labelKey),
      type: btn.type,
      selected: btn.selected(userRole),
      show: btn.show({ isServiceManager, insuracePortalUserRole, RTFMuser }),
    }));
};

export const getFilterData = (role) => {
  const roleMapping = {
    All: '',
    Driver: 'DRIVER',
    'Fleet Manager': 'FLMANAGER',
    Mechanic: 'MECHANIC',
    Admin: 'ADMIN',
    'Under Writer': 'UNDER_WRITER',
    'Loss Control': 'LOSS_CONTROL',
    'Claim Adjuster': 'CLAIM_ADJUSTER',
  };

  return roleMapping[role] || '';
};
